import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, Subject, of } from 'rxjs';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';
import { DebtorDocumentNumberType } from 'src/app/sharedcomp/constans/debtorDocumentType.constans';
import { debtorPhonePrefix, DocumentService } from '../../../_enums';
import { CustomValidators, DataService } from '../../../_helpers';
import { Template, User } from '../../../_models';
import { UserService } from '../../../_services';
import { icons } from '../../../sharedcomp/constans/icons.constans';

@Component({
  selector: 'app-new-profile',
  templateUrl: './new-profile.component.html',
  styleUrls: [
    './new-profile.component.css',
    '../../../../assets/css/new-component-view.css',
    '../../../../assets/css/new-form-elements.css',
    '../../../../assets/css/new-buttons-theme.css'
  ],
})
export class NewProfileComponent implements OnInit, OnDestroy {

  configurationProfileForm: FormGroup;
  icons: typeof icons;
  ddldebtorPhonePrefix: typeof DebtorDocumentNumberType;
  userKcoreId: string;
  updateSucess: boolean = false;
  updateError: boolean = false;

  getUser$: Observable<User>;
  private destroy$ = new Subject<void>();

  @ViewChild('parentDiv') parentDiv: ElementRef;
  initialFormValue: any;
  isconfigurationProfileFormChange: boolean;

  constructor(
    private _debtorPhonePrefix: debtorPhonePrefix,
    private userService: UserService,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private documentService: DocumentService
  ) {
    this.icons = icons;
    this.initProfileForm();
    this.ddldebtorPhonePrefix = DebtorDocumentNumberType;
  }

  ngOnInit() {
    let country = localStorage.getItem("country")
    this.ddldebtorPhonePrefix = this.getCountryData(country);
    this.dataService.loadSpinner(true);
    this.userKcoreId = localStorage.getItem('userId');
    if (this.userKcoreId != null) {
      this.setUserObservable();
    } else {
      this.goBack();
    }
  }

  setUserObservable() {
    this.getUser$ = this.userService.getUser(this.userKcoreId)
      .pipe(
        map((user: User) => ({
          name: user.name,
          email: user.email,
          phone_prefix: this.getPhoneValue(user.phone, 'countryCode'),
          phone: this.getPhoneValue(user.phone, 'phoneNumber'),
        })),
        tap(user => {
          this.configurationProfileForm.patchValue(user);
          this.initialFormValue = this.configurationProfileForm.getRawValue();
          this.configurationProfileForm.valueChanges
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => this.canSave());
          this.dataService.loadSpinner(false);
        }),
        catchError(error => {
          this.dataService.loadSpinner(false);
          console.error('Failed while trying to get the user details.' + error);
          return of(error);
        })
      );
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  numberOnly(event: KeyboardEvent): boolean {
    const key = event.key;
    // Permitir números del 0 al 9
    if (/\d/.test(key)) {
      return true;
    }
    return false;
  }

  getPhoneValue(value: string, stringType: 'countryCode' | 'phoneNumber'): string {
    if(stringType === 'countryCode'){
      return this.documentService.getCountryCode(value);
    } else if (stringType === 'phoneNumber') {
      return this.documentService.getPhoneNumberOnly(value);
    } else {
      return '';
    }
  }

  changeTemplate(event: Template) { }

  initProfileForm() {
    this.configurationProfileForm = this.fb.group({
      name: new FormControl('', [Validators.required, Validators.minLength(1)]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', [Validators.required, Validators.pattern('[0-9]*')]),
      phone_prefix: new FormControl('Seleccione', [Validators.required, CustomValidators.validateNoPreSelect])
    });
    this.configurationProfileForm.controls['email'].disable();
  }

  updateProfile(configurationProfileForm: FormGroup) {
    this.dataService.loadSpinner(true);
    let { phone_prefix, phone, ...profileForm } = configurationProfileForm.getRawValue();
    let newProfileForm = { ...profileForm, phone: phone_prefix + phone};

    this.userService.updateUser(this.userKcoreId, newProfileForm)
      .pipe(
        takeUntil(this.destroy$),
        tap(val => {
          this.updateError = false;
          this.updateSucess = true;
          this.dataService.loadSpinner(false);
        }),
        catchError(error => {
          this.updateSucess = false;
          this.updateError = true;
          this.dataService.loadSpinner(false);
          console.error('Failed while trying to update the user details.' + error);
          return of(error);
        })
      )
      .subscribe();
  }

  canSave() {
    this.isconfigurationProfileFormChange = JSON.stringify(this.initialFormValue) !== JSON.stringify(this.configurationProfileForm.getRawValue());
  }

  changePhonePrefix(event: string) {}

  changePhone(event: number) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCountryData(countryCode: string) {
    return this.ddldebtorPhonePrefix.filter((data => data.country === countryCode));
  }
}
